import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
  BehindSection,
  BehindLayout,
  BehindIntro,
  BehindKicker,
  BehindHeading,
  BehindCopy,
  BehindBody,
  BehindName,
  BehindArt,
  BehindSlab,
  BehindPanel,
  BehindYear,
  BehindPlace
} from './BehindStyledComponents'

const Behind = () => (
  <BehindSection>
    <BehindLayout>
      <BehindCopy>
        <BehindIntro>
          <BehindKicker>
            <FormattedMessage id="homepage.behind.kicker" />
          </BehindKicker>
          <BehindHeading>
            <FormattedMessage id="homepage.behind.heading" />
          </BehindHeading>
        </BehindIntro>
        <BehindBody>
          <FormattedMessage id="homepage.behind.origin" />
        </BehindBody>
        <BehindBody>
          <FormattedMessage
            id="homepage.behind.partners"
            values={{
              partner: <BehindName>Software Mansion</BehindName>,
              investor: <BehindName>Eyrir Ventures</BehindName>
            }}
          />
        </BehindBody>
      </BehindCopy>
      <BehindArt aria-hidden="true">
        <BehindSlab $tone="teal" />
        <BehindSlab $tone="pink" />
        <BehindPanel>
          <BehindYear>2018</BehindYear>
          <BehindPlace>Reykjavík</BehindPlace>
        </BehindPanel>
      </BehindArt>
    </BehindLayout>
  </BehindSection>
)

Behind.displayName = 'Behind'

export default Behind
